<template>
  <div class="mt-3 translations-group">
    <h4>Translations</h4>
    <div
      v-if="userLoggedIn"
      class="alert alert-danger"
      style="text-align: center">
      <h6 style="margin-bottom: 0;">
        !!!Please create a
        <router-link to="/backups" 
                     class="alert-link">snapshot</router-link>
        BEFORE performing any changes to the database!!!
      </h6>
    </div>
    <div class="row justify-content-end mb-3" style="margin-left:5px;">
      <div class="text-right">
        <form class="form-inline pull-right">
          <div class="form-group">
            <!-- Selection -->
            <label>
              Selected Labels:
              <span class="badge badge-light">
                {{ cartSet.labels.length }}
              </span>
            </label>
            <!-- New Set -->
            <label>Set:</label>
            <button
              type="button"
              class="btn btn-sm btn-outline-default m-1"
              @click="openSetListModal()">
              {{ selectedSet.name }}
            </button>

            <button
              v-if="userLoggedIn"
              type="button"
              class="btn btn-sm btn-success m-1"
              @click="saveCart()">
              Save
            </button>

            <!-- Import -->
            <button
              type="button"
              class="btn btn-sm btn-primary m-1"
              @click="showImport()">
              Import
            </button>
			
            <!-- Export -->
            <button
              type="button"
              class="btn btn-sm btn-primary m-1"
              @click="showExport()">
              Export
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="row actions-container">
      <!-- Search label -->
      <div class="col-md-2 text-left">
        <input
          id="label-filter"
          v-model="filter.label"
          name="label-filter"
          class="form-control form-control-sm"
          placeholder="Search label"
          @keyup="filterLabels()">
      </div>
      <!-- Select group -->
      <div class="col-md-2 text-left">
        <select
          id="label-filter-group"
          v-model="filter.group"
          name="label-filter-group"
          class="form-control form-control-sm"
          @change="filterLabels()">
          <option value selected>Select Group</option>
          <option
            v-for="(eachGroup, groupIndex) in groups"
            :key="groupIndex + 'option'"
            :value="eachGroup.id">{{ eachGroup.name }}</option>
        </select>
      </div>
      <!-- Add label -->
      <div class="col-md-8 text-right">
        <button
          v-if="userLoggedIn"
          class="btn btn-sm btn-primary"
          @click="addLabel()">
          Add label
        </button>
      </div>
    </div>
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 col-sm-8 col-xs-9 table-container" style="margin-left:13px;">
        <table
          class="table table-striped table-hover table-condensed">
          <tr class="bg-light">
            <th class="bg-light" style="border-left:1px solid #ddd">
              <div
                style="margin-left:10px"
                class="btn-group-toggle bg-light header-table"
                data-toggle="buttons">
                <span class="glyphicon glyphicon-pencil" aria-hidden="true"/>
                <span class="glyphicon glyphicon-trash" aria-hidden="true"/>
                <label
                  :class="{
                    active: allVisibleLabelsChecked,
                  }"
                  class="btn btn-sm"
                  style="padding-left: 0;margin-right: 5px">
                  <input
                    id="chkAllLabels"
                    v-model="
                      allVisibleLabelsChecked
                    "
                    type="checkbox"
                    autocomplete="off">
                  <span v-if="!allVisibleLabelsChecked" 
                        class="glyphicon glyphicon-ok-circle" 
                        aria-hidden="true"/>
                  <span v-if="allVisibleLabelsChecked" 
                        class="glyphicon glyphicon-ok-sign" 
                        aria-hidden="true"/>
                </label> 
                Label
              </div>
            </th>
            <td><div class="tcell">Group</div></td>
            <td
              v-for="language in allLanguages"
              :key="language.id">
              <div
                v-b-tooltip.hover
                :title="language.language"
                placement="top"
                class="tcell btn-group-toggle m-1"
                data-toggle="buttons">
                <label
                  :class="{
                    active: language.checked,
                  }"
                  class="tcell btn btn-sm btn-outline-primary languages-header">
                  <input
                    v-model="language.checked"
                    type="checkbox"
                    autocomplete="off"
                    @change="
                      addLanguageToSet(language)
                    ">
                  {{ language.language }}
                </label>
              </div>
            </td>
            <td/>
          </tr>
          <!-- Table contents -->
          <tr v-for="label in pagedLabels" 
              :key="label.id" 
              style="border-left: 1px solid rgb(222, 226, 230)">
            <th>
              <div
                class="btn-group-toggle selection-btns"
                data-toggle="buttons">
                <div
                  v-if="userLoggedIn"
                  class="btn-group"
                  role="group"
                  aria-label="Action button">
                  <button
                    type="button"
                    class="btn btn-sm"
                    style="margin-right: 3px"
                    @click="editLabel(label)">
                    <span class="glyphicon glyphicon-pencil" aria-hidden="true"/>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm"
                    @click="deleteLabel(label)">
                    <span class="glyphicon glyphicon-trash" aria-hidden="true"/>
                  </button>
                </div>

                <label
                  :class="{ active: label.checked }"
                  style="vertical-align:middle;display:inline-block;"
                  class="btn btn-sm">
                  <input
                    id="test"
                    v-model="label.checked"
                    type="checkbox"
                    autocomplete="off"
                    @change="addLabelToSet(label)">
                  <span v-if="!label.checked" 
                        class="glyphicon glyphicon-ok-circle" 
                        aria-hidden="true"/>
                  <span v-if="label.checked" 
                        class="glyphicon glyphicon-ok-sign" 
                        aria-hidden="true"/>
                </label>
                <span v-b-tooltip.hover
                      :title="label.name"
                      class="table-key">{{
                        label.name
                      }}</span>
              </div>
            </th>
            <td>
              <div v-if="label.group" class="tcell">
                {{ label.group.name }}
              </div>
            </td>
            <td
              v-for="lTranslation in label.translations"
              :key="lTranslation.id">
              <div
                v-b-tooltip.hover
                :title="lTranslation.value || 'N/A'"
                placement="top"
                class="tcell btn btn-sm btn-outline-secondary"
                @click="
                  addEditTranslation(
                    label,
                    lTranslation.language,
                    lTranslation
                  )
                ">
                {{ lTranslation.value || 'N/A' }}
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col col-lg-12 text-center">
        <pagination :labels="filteredLabels" :pagination="pagination"/>
      </div>
    </div>
    <modal-import v-if="showImportModal"
                  :action="actionInModal"
                  :groups="groups"
                  :label="labelInModal"
                  @close="showImportModal = false"/>

    <modal-add-edit-label v-if="showAddLabelModal"
                          :action="actionInModal"
                          :groups="groups"
                          :label="labelInModal"
                          @close="showAddLabelModal = false"/>

    <modal-add-edit-translation v-if="showTranslationModal"
                                :language="languageInTransModal"
                                :label="labelInTransModal"
                                :translation="transactionInTransModal"
                                @close="showTranslationModal = false"/>

    <modal-confirm v-if="showConfirmModal"
                   :msg="deleteMessage"
                   :action="confirmAction"
                   :action-name="confirmActionName"
                   @close="showConfirmModal = false"/>
    <modal-save-set v-if="showSaveSetModal"
                    :name="selectedSetName"
                    @close="showSaveSetModal = false"/>
    <modal-alert v-if="showAlertModal"
                 :msg="alertMessage"
                 @close="showAlertModal = false"/>
    <modal-export v-if="showExportModal"
                  :groups="groups"
                  :labels="labels"
                  :languages="allLanguages"
                  @close="showExportModal = false"/>
    <modal-set-list v-if="showSetListModal"
                    @close="showSetListModal = false"/>
  </div>
</template>

<script>
import 'firebase/firestore';
import { mapGetters, mapMutations, mapActions, } from 'vuex';
import EventBus from '@/services/eventBus';
import {
    db,
    labelsCollection,
    translationsCollection,
    setsCollection,
} from '@/services/firebaseConfig';
import ModalAddEditLabel from '@/components/ModalAddEditLabel';
import ModalAddEditTranslation from '@/components/ModalAddEditTranslation';
import ModalSaveSet from '@/components/ModalSaveSet';
import ModalSetList from '@/components/ModalSetList';
import ModalAlert from '@/components/ModalAlert';
import ModalConfirm from '@/components/ModalConfirm';
import Pagination from '@/components/Pagination/Pagination';
import ModalExport from '@/components/ModalExport';
import ModalImport from '@/components/ModalImport/ModalImport';

export default {
    name: 'Translations',
    components: {
        ModalAddEditTranslation,
        ModalAddEditLabel,
        ModalAlert,
        ModalConfirm,
        ModalSaveSet,
        ModalSetList,
        Pagination,
        ModalExport,
        ModalImport,
        EventBus,
    },
    data() {
        return {
            languages: [],
            labels: [],
            sets: [],
            filter: {
                group: '',
                label: null,
            },
            selectedSetName: '',
            filteredLabels: [],
            pagedLabels: [],
            pagination: {
                totalItems: null,
                currentPage: this.$route.query.page || 1,
                visiblePages: 100,
                itemsPerPage: 50,
            },
            selectedSet: {
                id: null,
                name: 'New Set...',
            },
            translations: [],
            idEnglishLanguage: null,
            showAddLabelModal: false,
            showImportModal: false,
            showTranslationModal: false,
            showSaveSetModal: false,
            showAlertModal: false,
            showConfirmModal: false,
            showExportModal: false,
            confirmAction: 'confirmDelete',
            confirmActionName: 'Delete',
            showSetListModal: false,
            actionInModal: 'add',
            groupsInModal: [],
            labelInModal: [],
            labelInTransModal: null,
            languageInTransModal: null,
            transactionInTransModal: null,
            alertMessage: null,
            deleteMessage: null,
            labelToBeDeleted: null,
        };
    },
    computed: {
        ...mapGetters([
            'userLoggedIn',
            'cart',
            'loading',
            'allLanguages',
            'groups',
        ]),
        cartSet() {
            return this.cart;
        },
        allVisibleLabelsChecked: {
            get: function() {
                let checkedLabels = this.pagedLabels.filter(
                    (eachLabel) => eachLabel.checked === true
                );
                return (
                    this.pagedLabels.length > 0 &&
                    checkedLabels.length === this.pagedLabels.length
                );
            },
            set: function(value) {
                let _self = this;
                this.pagedLabels = this.pagedLabels.map((eachLabel) => {
                    eachLabel.checked = value;
                    _self.addLabelToSet(eachLabel);
                    return eachLabel;
                });
            },
        },
    },
    watch: {
        '$route.query.page'(newPage) {
            let currentPage = newPage || 1;
            this.pagination.currentPage = currentPage;
            if (this.filter.group) {
                this.pageChanged(this.filteredLabels);
            } else {
                this.pageChanged(this.labels);
            }
        },
    },
    created() {
        this.getGroups();
        this.getAllLanguages();
        this.allLanguages.forEach((lang) => {
            if (lang.name === 'en') {
                this.idEnglishLanguage = lang.id;
            }
        });

        labelsCollection
            .orderBy('group')
            .get()
            .then((querySnapShot) => {
                querySnapShot.forEach((doc) => {
                    var docRef = labelsCollection.doc(doc.id);

                    translationsCollection
                        .where('label', '==', docRef)
                        .get()
                        .then((tQuerySnapShot) => {
                            this.translations = [];
                            
                            tQuerySnapShot.forEach((tDoc) => {
                                const data = {
                                    id: tDoc.id,
                                    value: tDoc.data().value,
                                    language: tDoc.data().language,
                                };
                                this.translations.push(data);
                            });

                            var lTranslations = [];
                            for (var i in this.allLanguages) {
                                var found = false;
                                for (var k in this.translations) {
                                    if (
                                        this.translations[k].language &&
                                        this.translations[k].language.id ===
                                            this.allLanguages[i].id
                                    ) {
                                        let objTrans = this.translations[k];
                                        objTrans.language = this.allLanguages[
                                            i
                                        ];
                                        lTranslations.push(objTrans);
                                        found = true;
                                        break;
                                    }

                                    if (
                                        this.translations[k].language &&
                                        this.translations[k].language.id ===
                                            this.allLanguages[i].name
                                    ) {
                                        let objTrans = this.translations[k];
                                        objTrans.language = this.allLanguages[
                                            i
                                        ];
                                        lTranslations.push(objTrans);
                                        found = true;
                                        break;
                                    }
                                }
                                if (!found) {
                                    lTranslations.push({
                                        id: null,
                                        value: null,
                                        language: this.allLanguages[i],
                                    });
                                }
                            }

                            var lblGroup = {
                                id: null,
                                name: null,
                            };

                            for (i in this.groups) {
                                found = true;
                                if (
                                    doc.data().group &&
                                    doc.data().group.id === this.groups[i].id
                                ) {
                                    lblGroup = this.groups[i];
                                }
                            }

                            const data = {
                                id: doc.id,
                                group: lblGroup,
                                name: doc.data().name,
                                translations: lTranslations,
                            };
                            this.labels.push(data);
                            this.pageChanged(this.labels);
                        });
                });
            });
    },
    mounted() {
        EventBus.$on('saveLabel', (label) => {
            this.saveLabel(label);
            this.showAddLabelModal = false;
        });
        EventBus.$on('updateLabel', (label) => {
            this.updateLabel(label);
            this.showAddLabelModal = false;
        });
        EventBus.$on('closeAlert', () => {
            this.showAlertModal = false;
        });
        EventBus.$on('confirmDelete', () => {
            this.confirmDelete();
            this.showConfirmModal = false;
        });
        EventBus.$on('saveTranslation', (translation) => {
            this.saveTranslation(translation);
            this.showTranslationModal = false;
        });
        EventBus.$on('saveSet', (translation) => {
            this.saveSet(translation);
            this.showSaveSetModal = false;
        });
        EventBus.$on('clearSet', () => {
            this.selectedSet = {
                id: null,
                name: 'New Set...',
                labels: [],
                languages: [],
            };
            this.loadCart(this.selectedSet);
            this.showSetListModal = false;
        });
        EventBus.$on('loadSelectedSet', (set) => {
            this.selectedSet = set;
            this.loadCart(set);
            this.showSetListModal = false;
        });
    },
    beforeDestroy() {
        EventBus.$off('closeAlert');
    },
    methods: {
        ...mapActions(['getAllLanguages', 'getGroups',]),
        ...mapMutations([
            'addLanguageToCart',
            'addLabelToCart',
            'startLoading',
            'stopLoading',
            'setCartId',
            'removeLabelFromCart',
            'clearCart',
        ]),
        getLabels() {
            labelsCollection
                .orderBy('group')
                .get()
                .then((querySnapShot) => {
                    querySnapShot.forEach((doc) => {
                        var docRef = labelsCollection.doc(doc.id);

                        translationsCollection
                            .where('label', '==', docRef)
                            .get()
                            .then((tQuerySnapShot) => {
                                this.translations = [];

                                tQuerySnapShot.forEach((tDoc) => {
                                    const data = {
                                        id: tDoc.id,
                                        value: tDoc.data().value,
                                        language: tDoc.data().language,
                                    };
                                    this.translations.push(data);
                                });

                                var lTranslations = [];
                                for (var i in this.allLanguages) {
                                    var found = false;
                                    for (var k in this.translations) {
                                        if (
                                            this.translations[k].language &&
                                            this.translations[k].language.id ===
                                                this.allLanguages[i].id
                                        ) {
                                            let objTrans = this.translations[k];
                                            objTrans.language = this.allLanguages[
                                                i
                                            ];
                                            lTranslations.push(objTrans);
                                            found = true;
                                            break;
                                        }
                                    }
                                    if (!found) {
                                        lTranslations.push({
                                            id: null,
                                            value: null,
                                            language: this.allLanguages[i],
                                        });
                                    }
                                }

                                var lblGroup = {
                                    id: null,
                                    name: null,
                                };

                                for (i in this.groups) {
                                    found = true;
                                    if (
                                        doc.data().group &&
                                        doc.data().group.id ===
                                            this.groups[i].id
                                    ) {
                                        lblGroup = this.groups[i];
                                    }
                                }

                                const data = {
                                    id: doc.id,
                                    group: lblGroup,
                                    name: doc.data().name,
                                    translations: lTranslations,
                                };
                                this.labels.push(data);
                                this.pageChanged(this.labels);
                            });
                    });
                });
        },
        filterLabels() {
            var _self = this;
            this.filteredLabels = this.labels.filter((label) => {
                let flag = true;
                if (_self.filter.label) {
                    flag = label.name
                        .toLowerCase()
                        .includes(_self.filter.label.toLowerCase());
                }
                if (!flag) {
                    for (var k in label.translations) {
                        if (
                            label.translations[k].language.id ===
                                _self.idEnglishLanguage &&
                            label.translations[k].value
                        ) {
                            flag = label.translations[k].value
                                .toLowerCase()
                                .includes(_self.filter.label.toLowerCase());
                            break;
                        }
                    }
                }
                if (flag && _self.filter.group) {
                    flag = label.group.id === _self.filter.group;
                }
                return flag;
            });
            this.pagination.currentPage = 1;
            this.pageChanged(this.filteredLabels);
        },
        addLabel() {
            this.actionInModal = 'add';
            this.labelInModal = [];
            this.showAddLabelModal = true;
        },
        editLabel(label) {
            this.actionInModal = 'edit';
            this.labelInModal = label;
            this.showAddLabelModal = true;
        },
        saveLabel(label) {
            var _self = this;
            labelsCollection
                .add({
                    name: label.name,
                    group: db.doc('groups/' + label.group.id),
                })
                .then((docRef) => {
                    let lTranslations = [];
                    let arrPromises = [];
                    for (let i in _self.allLanguages) {
                        // en is default to be added for new label
                        if (_self.allLanguages[i].name === 'en') {
                            let value = label.defaultTranslation;
                            arrPromises.push(
                                translationsCollection
                                    .add({
                                        value: value,
                                        label: db.doc('labels/' + docRef.id),
                                        language: db.doc(
                                            'languages/' +
                                                _self.allLanguages[i].id
                                        ),
                                    })
                                    .then((tDocRef) => {
                                        lTranslations[i] = {
                                            id: tDocRef.id,
                                            value: value,
                                            language: _self.allLanguages[i],
                                        };
                                    })
                            );
                        } else {
                            arrPromises.push(
                                (lTranslations[i] = {
                                    id: null,
                                    value: null,
                                    language: _self.allLanguages[i],
                                })
                            );
                        }
                    }

                    Promise.all(arrPromises).then(() => {
                        let group = label.group;
                        for (let i in _self.groups) {
                            if (group.id === _self.groups[i].id) {
                                group = _self.groups[i];
                                break;
                            }
                        }
                        const data = {
                            id: docRef.id,
                            group: group,
                            name: label.name,
                            translations: lTranslations,
                        };

                        _self.labels.push(data);
                        _self.pageChanged(_self.labels);
                    });
                })
                .catch((error) => {
                    this.errorMessage = error;
                });
        },
        updateLabel(label) {
            var _self = this;
            const docRef = labelsCollection.doc(label.id);
            docRef
                .update({
                    name: label.name,
                    group: db.doc('groups/' + label.group.id),
                })
                .then(() => {
                    for (let i in this.labels) {
                        if (this.labels[i].id === label.id) {
                            let group = label.group;
                            for (let j in _self.groups) {
                                if (group.id === _self.groups[j].id) {
                                    group = _self.groups[j];
                                    break;
                                }
                            }
                            this.labels[i].name = label.name;
                            this.labels[i].group = group;
                            break;
                        }
                    }
                    this.pageChanged(this.labels);
                })
                .catch((error) => {
                    this.errorMessage = error;
                });
        },
        deleteLabel(label) {
            this.deleteMessage =
                "Are you sure want to delete '" + label.name + "'";
            this.labelToBeDeleted = label;
            this.confirmAction = 'confirmDelete';
            this.confirmActionName = 'Delete';
            this.showConfirmModal = true;
        },
        confirmDelete() {
            labelsCollection
                .doc(this.labelToBeDeleted.id)
                .delete()
                .then(() => {
                    this.labels = this.labels.filter((item) => {
                        return item.id !== this.labelToBeDeleted.id;
                    });

                    // delete translations
                    var docRef = labelsCollection.doc(this.labelToBeDeleted.id);
                    var tranRef = translationsCollection.where(
                        'label',
                        '==',
                        docRef
                    );
                    let batch = db.batch();

                    tranRef.get().then((snapshot) => {
                        snapshot.docs.forEach((doc) => {
                            batch.delete(doc.ref);
                        });
                        return batch.commit();
                    });

                    this.pageChanged(this.labels);
                })
                .catch((error) => {
                    this.errorMessage = error;
                });
            this.showConfirmModal = false;
        },
        addEditTranslation(label, language, translation) {
            this.labelInTransModal = label;
            this.languageInTransModal = language;
            this.transactionInTransModal = translation;
            this.showTranslationModal = true;
        },
        saveTranslation(translation) {
            if (translation.id === null) {
                translationsCollection
                    .add({
                        value: translation.value,
                        label: db.doc('labels/' + translation.label.id),
                        language: db.doc(
                            'languages/' + translation.language.id
                        ),
                    })
                    .then((docRef) => {
                        translation.id = docRef.id;
                    })
                    .catch((error) => {
                        this.errorMessage = error;
                    });
            } else {
                const docRef = translationsCollection.doc(translation.id);
                docRef
                    .update({
                        value: translation.value,
                        label: db.doc('labels/' + translation.label.id),
                        language: db.doc(
                            'languages/' + translation.language.id
                        ),
                    })
                    .catch((error) => {
                        this.errorMessage = error;
                    });
            }
        },
        pageChanged(labels) {
            // Slice labels
            this.sliceLabels(labels);
            // Update @totalItems
            this.pagination.totalItems = labels.length;
        },
        sliceLabels(labels) {
            let sliceStart =
                (this.pagination.currentPage - 1) *
                this.pagination.itemsPerPage;
            let sliceEnd = sliceStart + Number(this.pagination.itemsPerPage);

            this.pagedLabels = labels.slice(sliceStart, sliceEnd);
        },
        openSetListModal() {
            this.showSetListModal = true;
        },
        addLabelToSet(label) {
            if (label.checked) {
                this.addLabelToCart(label.id);
            } else {
                this.removeLabelFromCart(label.id);
            }
        },
        addLanguageToSet(language) {
            if (language.checked) {
                this.addLanguageToCart(language.id);
            } else {
                this.removeLanguageFromCart(language.id);
            }
        },
        loadCart(set) {
            var _self = this;
            this.clearCart();
            this.labels.forEach((eachLabel) => {
                eachLabel.checked = false;
            });
            this.allLanguages.forEach((eachLanguage) => {
                eachLanguage.checked = false;
            });

            // update translations & global state
            this.setCartId(set.id);
            for (let i in set.labels) {
                this.addLabelToCart(set.labels[i].id);
                _self.labels.forEach((eachLabel) => {
                    if (eachLabel.id === set.labels[i].id) {
                        eachLabel.checked = true;
                    }
                });
            }
            for (let i in set.languages) {
                this.addLanguageToCart(set.languages[i].id);
                _self.allLanguages.forEach((eachLanguage) => {
                    if (eachLanguage.id === set.languages[i].id) {
                        eachLanguage.checked = true;
                    }
                });
            }
        },
        saveCart() {
            if (this.cartSet.id === null) {
                this.showSaveSetModal = true;
            } else {
                this.saveSet('');
            }
        },
        saveSet(name) {
            var setLanguages = this.cartSet.languages.map((eachLanguage) => {
                return db.doc('languages/' + eachLanguage);
            });
            var setLabels = this.cartSet.labels.map((idLabel) => {
                return db.doc('labels/' + idLabel);
            });
            if (this.cartSet.id === null) {
                setsCollection
                    .add({
                        name: name,
                        labels: setLabels,
                        languages: setLanguages,
                    })
                    .then((docRef) => {
                        this.selectedSet = {
                            id: docRef.id,
                            name: name,
                        };
                        this.setCartId(docRef.id);
                        this.alertMessage = 'New set saved successfully';
                        this.showAlertModal = true;
                    });
            } else {
                const docRef = setsCollection.doc(this.cartSet.id);
                docRef
                    .update({
                        labels: setLabels,
                        languages: setLanguages,
                    })
                    .then(() => {
                        this.alertMessage = 'selected set updated successfully';
                        this.showAlertModal = true;
                    });
            }
        },
        showExport() {
            this.showExportModal = true;
        },
        showImport() {
            this.showImportModal = true;
        },
        beforeDestroy() {
            EventBus.$off('saveLabel');
            EventBus.$off('updateLabel');
            EventBus.$off('closeAlert');
            EventBus.$off('confirmDelete');
            EventBus.$off('saveTranslation');
            EventBus.$off('saveSet');
            EventBus.$off('clearSet');
            EventBus.$off('loadSelectedSet');
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/pages/Translations/Translations.vue